import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { fetchData, joinDataArrays } from './utils/functions';

export default function ItemPage() {
  const itemQuery = useQuery('itemData', () => fetchData('item'));
  const extraImagesQuery = useQuery('extraImagesData', () => fetchData('extra-image'));
  const featuredImageQuery = useQuery('featuredImageData', () => fetchData('featured-image'));
  const { itemId } = useParams();
  const [treasure, setTreasure] = useState({});
  const [completeTreasure, setCompleteTreasure] = useState({});
  // const [largeImage, setLargeImage] = useState();

  useEffect(() => {
    if (itemId && itemQuery.data) {
      setTreasure(itemQuery.data.find(item => item.id === Number(itemId)))
    }
  }, [itemId, itemQuery.data])

  useEffect(() => {
    if (treasure, featuredImageQuery.data, extraImagesQuery.data) {
      const itemWithFeaturedImage = joinDataArrays(
        [treasure],
        'id',
        featuredImageQuery.data,
        'item_id',
        { featured_image: 'image' }
      );
      const itemWithExtraImages = joinDataArrays(
        itemWithFeaturedImage,
        'id',
        extraImagesQuery.data,
        'item_id',
        { id: 'id', extra_image: 'extra_image' },
        'extra_images'
      );
      setCompleteTreasure(itemWithExtraImages[0])
    }
  }, [treasure, featuredImageQuery.data, extraImagesQuery.data])

  return (
    <div>
      {completeTreasure ? (
        <div>
          <h2>{completeTreasure.description}</h2>
          <div>Estimated Total: {`$${(parseFloat(treasure.minimum_return) + parseFloat(treasure.estimated_shipping)).toFixed(2)}`}</div>
          <div>Estimated Price: {`$${treasure.minimum_return}`}</div>
          <div>Estimated Shipping: {`$${treasure.estimated_shipping}`}</div>
          <div>Featured Image:</div>
            <img
              src={`${import.meta.env.VITE_API_URL}image/${completeTreasure.featured_image}`}
              alt={completeTreasure.featured_image}
              className="large-img"
            />
          <div>
            <div>
              Extra Images:
            </div>
            {/* {completeTreasure.extra_images.map((image) => (
              <img
                key={image.id}
                src={`${import.meta.env.VITE_API_URL}image/${image.extra_image}`}
                alt={image.extra_image}
                className="img"
              />
            ))} */}
          </div>
        </div>
      ) : ('This Treasure is Lost')}
    </div>
  )
}
